<template>
	<div class="laser-details">
		<div class="laser-details__content">
			<div class="laser-details__header">
				<span class="laser-details__header-title">
					Laser Details
				</span>

				<Button
					:className="'btn--icon-only-circle'"
					labelText=""
					:btnClick="formsHistory"
					iconClassName="icon-history"
					:iconBeforeLabel="true"
				/>
			</div>

			<hr class="laser-details__header-horizontal-line" />

			<div class="form-info-items">
				<div class="form-info-items__group-primary">
					<div class="form-info-items__name">
						<span class="laser-details-title">Form Name</span>
						<p class="laser-details-text">
							{{ this.form && this.form.name }}
						</p>
					</div>

					<div class="form-info-items__revision">
						<span class="laser-details-title">Form Revision</span>
						<p class="laser-details-text">
							{{ this.form && this.form.formRevision }}
						</p>
					</div>
				</div>

				<div class="form-info-items__description">
					<span class="laser-details-title">Form Description</span>
					<p class="laser-details-text">
						{{ this.form && this.form.description }}
					</p>
				</div>

				<div class="form-info-items__group-secondary">
					<div class="form-info-items__file" v-if="fileUploaded">
						<span class="laser-details-title">Selected File</span>
						<span class="form-info-items__file-icon">
							<i class="icon icon-document"></i>
						</span>
						<a @click="getFile" class="link uploaded-file__name">
							{{ fileNameUploaded }}
						</a>
						<ul class="form-info-items__file-details">
							<li class="form-info-items__file-details-item">
								{{ this.pdfDate }}
							</li>
							<li class="form-info-items__file-details-item">
								{{ this.pdfTime }}
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="form-changes">
				<span class="laser-details-title">Included Form Charges</span>

				<hr class="form-changes__horizontal-line" />

				<ul class="form-changes__list">
					<li class="form-changes__list-item">
						<span class="laser-details-title">Type</span>
						<p class="laser-details-text">
							{{ formType(form) }}
						</p>
					</li>
					<li class="form-changes__list-item">
						<span class="laser-details-title">Price</span>
						<p class="laser-details-text">
							{{ formattedPrice(form) }}
						</p>
					</li>
					<li class="form-changes__list-item">
						<span class="laser-details-title">Cost</span>
						<p class="laser-details-text">
							{{ formattedCost(form) }}
						</p>
					</li>
				</ul>
			</div>

			<div class="laser-details__main-content">
				<LaserDetailsContent v-model="form.inputFields" />
			</div>
		</div>
	</div>
</template>

<script>
import Button from '@/components/forms/button/button';
import LaserDetailsContent from '@/views/form-designer/laser-details-content.vue';
import BaseComponent from '@/mixins/base-component';
import PdfFnForm from '@/mixins/forms/pdf-fn-form';
import moment from 'moment';
import _ from 'lodash';

export default {
	name: 'LaserDetails',
	mixins: [BaseComponent, PdfFnForm],
	model: {
		prop: 'form'
	},
	components: {
		Button,
		LaserDetailsContent
	},
	props: {
		label: {
			type: String,
			default: ''
		},
		labelInsideClassName: {
			type: String,
			default: ''
		},
		btnClick: {
			type: Function,
			default: () => {}
		},
		autoSave: {
			type: Boolean,
			default: true
		},
		formData: {
			type: Object
		},
		refreshList: {
			type: Boolean,
			default: false
		},
		form: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			privilegedUser: true,
			resultTextarea: '',
			classNameInput: 'textarea__input',
			placeholder: '',
			maxLengthInput: 200,
			formSaveValue: {
				text: 'Save',
				value: 'default'
			},
			navigatingFromCustomer: false
			// formSaveOptions: [
			// 	{
			// 		text: 'Save',
			// 		value: 'default'
			// 	},
			// 	{
			// 		text: 'Cancel',
			// 		value: 'cancel'
			// 	}
			// ],
			// formCost: 0,
			// formPrice: 0
		};
	},
	created() {
		this.navigatingFromCustomer = _.startsWith(
			this.$route.path,
			'/clients'
		);
	},
	computed: {
		effectiveDate() {
			return this.formatDateTime(this.form.effectiveDate);
		},
		pdfDate() {
			if (this.form.modifiedDate) {
				return this.formatDate(this.form.rowModifiedDate);
			}
			return this.formatDate(this.form.rowCreatedDate);
		},
		pdfTime() {
			if (this.form.modifiedDate) {
				return this.formatTime(this.form.rowModifiedDate);
			}
			return this.formatTime(this.form.rowCreatedDate);
		},
		customerPath() {
			if (_.isEmpty(this.$route.params.customerId)) {
				return '';
			}

			return `/clients/${this.$route.params.customerId}`;
		}
	},
	methods: {
		formatDateTime(value) {
			if (value) {
				return moment(String(value)).format('YYYY-MM-DD hh:mm');
			}
		},
		formatDate(value) {
			if (value) {
				return moment(String(value)).format('YYYY-MM-DD');
			}
		},
		formatTime(value) {
			if (value) {
				return moment(String(value)).format('hh:mm');
			}
		},
		formsHistory() {
			if (this.navigatingFromCustomer) {
				this.$router.push({
					path: `${this.customerPath}/forms/${this.form.id}/history/`
				});
				return;
			}
			this.$router.push({
				path: `${this.customerPath}/forms/history/${
					this.form.id
				}/${encodeURIComponent(this.form.name)}`
			});
		},
		formType(form) {
			if (form.formType === 'L') {
				return 'Law';
			}
			if (form.formType === 'W') {
				return 'WKFS';
			}
			if (form.formType === 'I') {
				return 'Iowa ADA';
			}
			if (form.formType === 'M') {
				return 'MN ADA';
			}
			if (form.formType === 'OR'){
				return 'OR ADA';
			}
			return 'N/A';
		},
		formattedCost(form) {
			if (form.formType === 'L' || form.formType === 'OR') {
				if (!form.formCost) {
					return '0.0000';
				}
				return form.formCost.toFixed(4);
			} else {
				return 'N/A';
			}
		},
		formattedPrice(form) {
			if (form.formType === 'L' || form.formType === 'OR') {
				if (!form.formPrice) {
					return '0.0000';
				}
				return form.formPrice.toFixed(4);
			} else {
				return 'N/A';
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
  * [Description]
  *
  * Laser Form details
  * Can use SCSS variables = TRUE
  *
  *
**/

.laser-details {
	&__content {
		background: $white;
		padding: $padding-md;
		display: grid;

		@include mq($until: sm-l) {
			border-top: 1px solid $neutral-3;
		}

		@include mq($from: sm-l) {
			border: 1px solid $neutral-3;
			border-radius: 4px;
			margin-bottom: $gutter-xxl;
		}
	}

	&__header-horizontal-line {
		@include create-horizontal-line(16px, 1px, $gutter-lg, $neutral-3);
		@include mq($until: md) {
			margin-bottom: $gutter-xl;
		}
	}

	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;

		&-title {
			color: $black;
			font-size: $default-font-size;
			font-weight: $medium-font-weight;
		}
		.btn {
			font-size: 24px;
		}
	}
}

.laser-details-title {
	display: block;
	font-weight: $medium-font-weight;
	font-size: $label-font-size;
	margin-bottom: $gutter-sm;
	color: inherit;
}

.laser-details-text {
	font-size: 14px;
}

.form-info-items {
	&__name,
	&__revision,
	&__description,
	&__date,
	&__file {
		.laser-details-title {
			margin-top: 0;
			margin-bottom: $gutter-md;
		}
	}

	&__revision,
	&__description,
	&__date,
	&__file {
		.laser-details-title {
			margin-top: $gutter-xl;
		}
	}

	&__date {
		&-icon {
			display: inline-block;
		}
		> .laser-details-text {
			display: inline-block;
			padding-left: $padding-sm;
		}
	}

	&__file {
		display: inline-block;
		&-icon {
			display: inline-block;
		}

		.uploaded-file__name {
			margin-left: $gutter-sm;
		}

		&-details {
			display: flex;
			justify-content: flex-end;
			font-size: $default-font-size - 4;
			color: $neutral-2;
			margin-top: $gutter-sm;

			&-item {
				&:first-child {
					margin-right: $gutter-sm;
				}
			}
		}
	}

	@include mq($from: md) {
		&__description,
		&__group-primary {
			min-width: 50%;
			max-width: 50%;
			margin-top: $gutter-md;
		}

		&__revision {
			.laser-details-title {
				margin-top: $gutter-xl;
			}
		}

		&__description {
			.laser-details-title {
				margin-top: 0;
			}
		}

		&__group-secondary {
			margin-top: $gutter-xl;
			min-width: 100%;
			display: flex;
		}

		&__date {
			min-width: 50%;
		}
	}

	@include mq($from: lg) {
		&__description,
		&__group-primary {
			min-width: initial;
			max-width: initial;
		}

		&__description {
			margin-top: $gutter-md;
			max-width: 45%;
		}

		&__group-secondary {
			margin-top: $gutter-md;
			min-width: initial;
			display: initial;
		}

		&__date {
			.laser-details-title {
				margin-top: 0;
			}
			min-width: 50%;
		}
	}
}

.form-changes {
	margin-bottom: $gutter-xxl;
	max-width: 100%;

	.laser-details-title {
		margin-top: 0;
	}

	&__horizontal-line {
		@include create-horizontal-line(16px, 1px, $gutter-lg, $neutral-3);
	}

	&__list {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;

		&-item {
			.laser-details-title {
				margin-top: 0;
				margin-bottom: $gutter-md;
			}
		}
	}

	@include mq($from: md) {
		max-width: 70%;
	}

	@include mq($from: lg) {
		max-width: 45%;
	}
}
</style>
